import dayjs from "dayjs";
import {
  QualityLineProps,
  OrderProps,
  RoleProps,
  UserDataProps,
  reportProps,
} from "../interfaces/interfaces";

export const order_initial_state: OrderProps = {
  key: 0,
  OID: null,
  OrderId: null,
  RigNumber: null,
  Connection: "",
  PinRecuts: 0,
  BoxRecuts: 0,
  PinReface: 0,
  BoxReface: 0,
  GCRecord: 0,
  QualityLines: [],
  RigNumberDetail: {
    OID: 0,
    Name: "",
  },
};

export const employee_initial_state: UserDataProps = {
  key: 0,
  OID: "",
  Name: "",
  UserName: "",
  IsActive: true,
};

export const order_line_initial_state: QualityLineProps = {
  key: 0,
  Order: 0,
  OID: 0,
  Employee: null,
  Date: dayjs(),
  PinBox: "pin",
  Gauge: 0,
  Length: 0,
  NoseDiameter: 0,
  CylinderDiameter: 0,
  Lead: 0,
  Taper: 0,
  BevelDiameter: 0,
  userDetail: employee_initial_state,
};

export const userData: UserDataProps = {
  key: 0,
  OID: "",
  Name: "",
  UserName: "Admin",
  IsActive: true,
};

export const user_initial_state: UserDataProps = {
  key: 0,
  OID: "",
  UserName: "",
  Name: "",
  IsActive: true,
  Password: "",
  Role: "",
};

export const roleData: RoleProps = {
  key: 0,
  Oid: 0,
  Name: "Administrators",
  IsAdministrative: true,
  CanEditModel: false,
};

export const role_initial_state: RoleProps = {
  key: 0,
  Oid: 0,
  Name: "",
  IsAdministrative: false,
  CanEditModel: false,
};

export const reportListData: reportProps[] = [
  {
    key: 0,
    name: "Order Details",
    dataType: "Order",
  },
  {
    key: 1,
    name: "QTY",
    dataType: "Order",
  },
  {
    key: 2,
    name: "QTY 2",
    dataType: "Order",
  },
  {
    key: 3,
    name: "QTY 4",
    dataType: "Order",
  },
  {
    key: 4,
    name: "QTY 5",
    dataType: "Order",
  },
  {
    key: 5,
    name: "QTY3",
    dataType: "Order",
  },
];
